import { Routes, Route, Navigate } from "react-router-dom";
import Navigation from "../../../components/Navigation/Navigation.js";
import DistanceTable from "./DistanceTable.js";

const Progress = () => {
  const tabs = [
    { path: "distance145", label: "145M(Kungdo)" },
    { path: "distance90", label: "90M(TarscaShild)" },
    { path: "distance70", label: "70M(Puta)" },
    { path: "distance30", label: "30M(Zamby)" },
  ];

  return (
    <>
      <Navigation tabs={tabs} basePath="/game-status/progress" variant="tab" />

      <Routes>
        <Route path="/" element={<Navigate to="distance145" replace />} />
        <Route path=":distanceParam" element={<DistanceTable />} />
      </Routes>
    </>
  );
};
export default Progress;
